module.exports = __webpack_public_path__ + "static/media/11.e70e7833.JPG";